// extracted by mini-css-extract-plugin
module.exports = {"container":"Media_container__27fzO","imageContainer":"Media_imageContainer__3qUIj","picture":"Media_picture__--1qJ","deleteButton":"Media_deleteButton__1h0gj"};